import { render, staticRenderFns } from "./WaitingListCancel.vue?vue&type=template&id=8fb3b532&scoped=true"
import script from "./WaitingListCancel.vue?vue&type=script&lang=js"
export * from "./WaitingListCancel.vue?vue&type=script&lang=js"
import style0 from "./WaitingListCancel.vue?vue&type=style&index=0&id=8fb3b532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb3b532",
  null
  
)

export default component.exports